module.exports = __webpack_public_path__ + "img/logo.408a0def.jpg";